import { useState } from "react";
import { AppWindow } from "lucide-react";

export function GenericAppGlyph({ size = 24 }: { size?: number }) {
  return <AppWindow size={size} color="#667085" aria-hidden="true" />;
}

/** Image metadata only; never requests an app's runtime favicon. */
export function AppImage({ url, size = 24, eager = false }: { url?: string | null; size?: number; eager?: boolean }) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  return url && failedUrl !== url ? (
    <img src={url} alt="" loading={eager ? "eager" : "lazy"} decoding="async" onError={() => setFailedUrl(url)} />
  ) : <GenericAppGlyph size={size} />;
}
